import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";
import verified from "assets/images/verified.png";
import pending from "assets/images/load.png";

const QUESTION_FILTER_KEYS = [
  "subject_id",
  "topic_id",
  "level_id",
  "approved_status",
  "qType",
  "language_converted",
  "for_book",
  "search",
];

const EMPTY_QUESTION_FILTERS = {
  subject_id: "",
  topic_id: "",
  level_id: "",
  approved_status: "",
  qType: "",
  language_converted: "",
  for_book: "",
  search: "",
};

const getQuestionFilterStorageKey = () => {
  try {
    const admin = JSON.parse(localStorage.getItem("admin_details") || "{}");
    const identity = admin?._id || admin?.id || admin?.mobile || admin?.role || "default";
    return `agriquiz:fixed-question-filters:${identity}`;
  } catch (error) {
    return "agriquiz:fixed-question-filters:default";
  }
};

const readFixedQuestionFilters = (storageKey) => {
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || "{}");
    return QUESTION_FILTER_KEYS.reduce(
      (filters, key) => ({ ...filters, [key]: String(saved?.[key] || "") }),
      { ...EMPTY_QUESTION_FILTERS }
    );
  } catch (error) {
    return { ...EMPTY_QUESTION_FILTERS };
  }
};

export default class Questions extends Component {
  topicListParams = new URLSearchParams(window.location.search);

  filterStorageKey = getQuestionFilterStorageKey();

  hasSavedFilters = Boolean(localStorage.getItem(this.filterStorageKey));

  savedFilters = readFixedQuestionFilters(this.filterStorageKey);

  hasUrlFilterContext =
    this.topicListParams.get("filtered_navigation") === "true" ||
    QUESTION_FILTER_KEYS.some((key) => this.topicListParams.has(key));

  initialFilters = this.hasUrlFilterContext
    ? QUESTION_FILTER_KEYS.reduce(
        (filters, key) => ({ ...filters, [key]: this.topicListParams.get(key) || "" }),
        { ...EMPTY_QUESTION_FILTERS }
      )
    : this.savedFilters;

  state = {
    allJobs: [],
    message: "",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notification: false,
    noticolor: "success",
    per_page: Math.max(1, parseInt(this.topicListParams.get("list_limit"), 10) || 20),
    page_no: Math.max(1, parseInt(this.topicListParams.get("list_page"), 10) || 1),
    redirect: false,
    allSubjects: [],
    alltopics: [],
    allLevels: [],
    filtersFixed:
      this.hasSavedFilters &&
      (!this.hasUrlFilterContext || this.topicListParams.get("fixed_filters") === "true"),
    topicFilterName: this.topicListParams.get("topic_name") || "",
    filters: this.initialFilters,
  };
  componentDidMount() {
    this.getAllSubjects();
    if (this.state.filters.subject_id) {
      this.getTopicBySubject();
    }
    if (this.state.filters.subject_id && this.state.filters.topic_id) {
      this.getLevelByTopic();
    }
    this.getAllQuestions(this.state.page_no, this.state.per_page);
  }

  getAllSubjects = async () => {
    if (init() === "success") {
      const resp = await axios.get(`${Constants.getUrls.getAllSubjects}?search=&limit=1000&page=1`);
      this.setState({
        allSubjects: resp?.data?.data?.docs || [],
      });
    }
  };

  getTopicBySubject = async () => {
    if (init() === "success" && this.state.filters.subject_id) {
      const resp = await axios.get(
        `${Constants.getUrls.getAllTopics}?subject_id=${this.state.filters.subject_id}&page=1&limit=1000`
      );
      this.setState({
        alltopics: resp?.data?.data?.docs || [],
      });
    } else {
      this.setState({ alltopics: [] });
    }
  };

  getLevelByTopic = async () => {
    const { subject_id, topic_id } = this.state.filters;
    if (init() === "success" && subject_id && topic_id) {
      const resp = await axios.get(
        `${Constants.getUrls.getAllLevels}?subject_id=${subject_id}&topic_id=${topic_id}&page=1&limit=1000`
      );
      this.setState({ allLevels: resp?.data?.data?.docs || [] });
    } else {
      this.setState({ allLevels: [] });
    }
  };

  getAllQuestions = (page = 1, limit = this.state.per_page) => {
    try {
      if (init() === "success") {
        const params = new URLSearchParams({
          page: String(page),
          limit: String(limit),
        });
        const {
          subject_id,
          topic_id,
          level_id,
          approved_status,
          qType,
          language_converted,
          for_book,
          search,
        } = this.state.filters;
        if (subject_id) params.append("subject_id", subject_id);
        if (topic_id) params.append("topic_id", topic_id);
        if (level_id) params.append("level_id", level_id);
        if (approved_status) params.append("approved_status", approved_status);
        if (qType) params.append("qType", qType);
        if (language_converted) params.append("language_converted", language_converted);
        if (for_book) params.append("for_book", for_book);
        if (search) params.append("search", search);

        axios
          .get(`${Constants.getUrls.getAllQuestions}?${params.toString()}`)
          .then((resp) => {
            if (resp.data.status === "success") {
              this.setState({
                allJobs: resp.data.data.docs,
                pagination: resp.data.data, // whole pagination object from backend
                page_no: resp.data.data.page,
                notification: true,
                noticolor: "success",
                message: resp.data.message,
              });
              setTimeout(() => {
                this.setState({ notification: false, message: "" });
              }, 2500);
            } else {
              this.setState({
                notification: true,
                noticolor: "error",
                message: resp.data.message,
              });
            }
          })
          .catch((err) => {
            this.setState({
              notification: true,
              noticolor: "error",
              message: err.response?.message || "Error fetching questions",
            });
            setTimeout(() => {
              this.setState({ notification: false, message: "" });
            }, 2500);
          });
      } else {
        this.setState({ redirect: true });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllQuestions(1, newLimit); // reset to first page with new limit
    });
  };

  // ✅ Handle page change (from DataTable)
  handlePageChange = (newPage) => {
    this.getAllQuestions(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteSubject + id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              notification: true,
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState(
                {
                  notification: false,
                  message: "",
                },
                () => {
                  this.getAllQuestions();
                }
              );
            }, 2500);
          }
        })
        .catch((err) => {
          //   console.log(err);
          this.setState({
            notification: true,
            message: err.response?.message,
          });
          setTimeout(() => {
            this.setState(
              {
                notification: false,
                message: "",
              },
              () => {
                this.getAllQuestions();
              }
            );
          }, 2500);
        });
    } else {
      window.location.assign("/");
    }
  };

  handleFilterInput = (name, value) => {
    if (name === "subject_id") {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            subject_id: value,
            topic_id: "",
            level_id: "",
          },
          alltopics: [],
          allLevels: [],
        }),
        () => this.getTopicBySubject()
      );
      return;
    }

    if (name === "topic_id") {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            topic_id: value,
            level_id: "",
          },
          allLevels: [],
        }),
        () => this.getLevelByTopic()
      );
      return;
    }

    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }));
  };

  applyFilters = () => {
    if (this.state.filtersFixed) {
      localStorage.setItem(this.filterStorageKey, JSON.stringify(this.state.filters));
    }
    this.syncFilterUrl();
    this.getAllQuestions(1, this.state.per_page);
  };

  fixFilters = () => {
    localStorage.setItem(this.filterStorageKey, JSON.stringify(this.state.filters));
    this.setState({ filtersFixed: true }, () => {
      this.syncFilterUrl();
      this.getAllQuestions(1, this.state.per_page);
    });
  };

  syncFilterUrl = () => {
    const params = new URLSearchParams();
    QUESTION_FILTER_KEYS.forEach((key) => {
      if (this.state.filters[key]) params.set(key, this.state.filters[key]);
    });
    if (this.state.filtersFixed) params.set("fixed_filters", "true");
    const query = params.toString();
    window.history.replaceState({}, "", query ? `/questions?${query}` : "/questions");
  };

  resetFilters = () => {
    localStorage.removeItem(this.filterStorageKey);
    window.history.replaceState({}, "", "/questions");
    this.setState(
      {
        filters: { ...EMPTY_QUESTION_FILTERS },
        filtersFixed: false,
        alltopics: [],
        allLevels: [],
        topicFilterName: "",
      },
      () => this.getAllQuestions(1, this.state.per_page)
    );
  };

  getQuestionEditorSearch = () => {
    const params = new URLSearchParams();
    QUESTION_FILTER_KEYS.forEach((key) => {
      if (this.state.filters[key]) params.set(key, this.state.filters[key]);
    });
    if (this.state.topicFilterName) params.set("topic_name", this.state.topicFilterName);
    if (this.state.filtersFixed) params.set("fixed_filters", "true");
    params.set("list_page", String(this.state.page_no));
    params.set("list_limit", String(this.state.per_page));
    params.set("filtered_navigation", "true");
    return `?${params.toString()}`;
  };

  render() {
    const { allJobs, pagination } = this.state;
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    } else {
      return (
        <div>
          <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Questions List
                    {this.state.topicFilterName ? ` • ${this.state.topicFilterName}` : ""}
                  </MDTypography>
                </MDBox>
                <Grid item sm={4} px={2} align="right">
                  <Link to="/approveQuestions/1">
                    <MDButton
                      variant="contained"
                      size="small"
                      color="warning"
                      style={{ marginRight: "10px" }}
                    >
                      Approve Questions
                    </MDButton>
                  </Link>
                  <Link to="/addQuestion">
                    <MDButton variant="contained" size="small" color="primary">
                      Create
                    </MDButton>
                  </Link>
                  <Link to="/add-bulk-question">
                    <MDButton
                      variant="contained"
                      size="small"
                      color="success"
                      style={{ marginLeft: "10px" }}
                    >
                      Bulk-Import
                    </MDButton>
                  </Link>
                  <Link to="/add-ai-question">
                    <MDButton
                      variant="contained"
                      size="small"
                      color="info"
                      style={{ marginLeft: "10px" }}
                    >
                      Question With AI
                    </MDButton>
                  </Link>
                </Grid>

                <MDBox px={2} py={2}>
                  {this.state.filtersFixed && (
                    <MDBox
                      mb={2}
                      px={2}
                      py={1.25}
                      borderRadius="lg"
                      sx={{
                        backgroundColor: "rgba(40,183,111,0.1)",
                        border: "1px solid rgba(40,183,111,0.32)",
                      }}
                    >
                      <MDTypography variant="button" color="success" fontWeight="bold">
                        Fixed filter is active. It will be restored automatically until Reset Filters is clicked.
                      </MDTypography>
                    </MDBox>
                  )}
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <InputLabel>Select Subject</InputLabel>
                      <Select
                        value={this.state.filters.subject_id}
                        onChange={(e) => this.handleFilterInput("subject_id", e.target.value)}
                        style={{ width: "100%", height: "45px", color: "#111" }}
                      >
                        <MenuItem value="">All Subjects</MenuItem>
                        {this.state.allSubjects.map((item) => (
                          <MenuItem key={item._id} value={item._id}>
                            {item.subject_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputLabel>Select Topic</InputLabel>
                      <Select
                        value={this.state.filters.topic_id}
                        onChange={(e) => this.handleFilterInput("topic_id", e.target.value)}
                        style={{ width: "100%", height: "45px", color: "#111" }}
                        disabled={!this.state.filters.subject_id}
                      >
                        <MenuItem value="">All Topics</MenuItem>
                        {this.state.alltopics.map((item) => (
                          <MenuItem key={item._id} value={item._id}>
                            {item.topic_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputLabel>Select Level</InputLabel>
                      <Select
                        value={this.state.filters.level_id}
                        onChange={(e) => this.handleFilterInput("level_id", e.target.value)}
                        style={{ width: "100%", height: "45px", color: "#111" }}
                        disabled={!this.state.filters.topic_id}
                      >
                        <MenuItem value="">All Levels</MenuItem>
                        {this.state.allLevels.map((item) => (
                          <MenuItem key={item._id} value={item._id}>
                            {item.level_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={this.state.filters.approved_status}
                        onChange={(e) => this.handleFilterInput("approved_status", e.target.value)}
                        style={{ width: "100%", height: "45px", color: "#111" }}
                      >
                        <MenuItem value="">All Status</MenuItem>
                        <MenuItem value="approved">Approved</MenuItem>
                        <MenuItem value="pending">Pending</MenuItem>
                        <MenuItem value="rejected">Rejected</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputLabel>Difficulty</InputLabel>
                      <Select
                        value={this.state.filters.qType}
                        onChange={(e) => this.handleFilterInput("qType", e.target.value)}
                        style={{ width: "100%", height: "45px", color: "#111" }}
                      >
                        <MenuItem value="">All Types</MenuItem>
                        <MenuItem value="easy">easy</MenuItem>
                        <MenuItem value="medium">medium</MenuItem>
                        <MenuItem value="hard">hard</MenuItem>
                        <MenuItem value="medium-hard">medium-hard</MenuItem>
                        <MenuItem value="hardest">hardest</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputLabel>Language Conversion</InputLabel>
                      <Select
                        value={this.state.filters.language_converted}
                        onChange={(e) =>
                          this.handleFilterInput("language_converted", e.target.value)
                        }
                        style={{ width: "100%", height: "45px", color: "#111" }}
                      >
                        <MenuItem value="">All Questions</MenuItem>
                        <MenuItem value="true">Hindi Converted</MenuItem>
                        <MenuItem value="false">Hindi Not Converted</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputLabel>Book Selection</InputLabel>
                      <Select
                        value={this.state.filters.for_book}
                        onChange={(e) => this.handleFilterInput("for_book", e.target.value)}
                        style={{ width: "100%", height: "45px", color: "#111" }}
                      >
                        <MenuItem value="">All Questions</MenuItem>
                        <MenuItem value="yes">Selected for Book</MenuItem>
                        <MenuItem value="no">Not Selected for Book</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputLabel>Search Question</InputLabel>
                      <TextField
                        value={this.state.filters.search}
                        onChange={(e) => this.handleFilterInput("search", e.target.value)}
                        placeholder="Type question text"
                        style={{ width: "100%" }}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") this.applyFilters();
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MDButton
                        variant="contained"
                        size="small"
                        color="info"
                        onClick={this.applyFilters}
                      >
                        Apply Filters
                      </MDButton>
                      <MDButton
                        variant="contained"
                        size="small"
                        color="success"
                        onClick={this.fixFilters}
                        style={{ marginLeft: "10px" }}
                      >
                        {this.state.filtersFixed ? "Update Fixed Filter" : "Fix This Filter"}
                      </MDButton>
                      <MDButton
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={this.resetFilters}
                        style={{ marginLeft: "10px" }}
                      >
                        Reset Filters
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>

                <MDBox>
                  <DataTable
                    table={{
                      columns: [
                        { Header: "serial", accessor: "serial", width: "6%" },
                        { Header: "approved", accessor: "approved", width: "5%" },
                        { Header: "question", accessor: "question" },
                        { Header: "subject", accessor: "subject" },
                        { Header: "topic", accessor: "topic" },
                        { Header: "action", accessor: "action" },
                      ],
                      rows: this.state.allJobs.map((job, index) => ({
                        serial: index + 1,
                        approved: (
                          <>
                            <Link to={"/approveQuestions/" + (parseInt(index) + 1)}>
                              <img
                                src={job.approved_status == "approved" ? verified : pending}
                                height={job.approved_status == "approved" ? "50px" : "30px"}
                              />
                            </Link>
                          </>
                        ),
                        question: job.question + " (" + job.question_type + ")",
                        subject: job?.subject_id?.subject_name,
                        topic: job?.topic_id?.topic_name,
                        // image: (
                        //   <>
                        //     <img src={Constants.imageDomain + job.subject_poster} height="100px" />
                        //   </>
                        // ),
                        // content: job.content,

                        action: (
                          <>
                            <div>
                              <Link
                                to={{
                                  pathname: "/updateQuestion/" + job._id,
                                  search: this.getQuestionEditorSearch(),
                                }}
                              >
                                <MDButton variant="outlined" size="small" color="success">
                                  Update
                                </MDButton>
                              </Link>
                            </div>
                            <div style={{ marginTop: "1rem" }}>
                              <MDButton
                                variant="outlined"
                                size="small"
                                color="error"
                                onClick={() => this.handleDelete(job._id)}
                              >
                                Delete
                              </MDButton>
                            </div>
                          </>
                        ),
                      })),
                    }}
                    entriesPerPage={{ defaultValue: this.state.per_page, entries: [10, 25, 50, 100] }}
                    page_no={this.state.pagination?.page}
                    totalPages={this.state.pagination?.totalPages}
                    hasNextPage={this.state.pagination?.hasNextPage}
                    hasPrevPage={this.state.pagination?.hasPrevPage}
                    isnextPage={this.state.pagination?.nextPage}
                    prevPage={this.state.pagination?.prevPage}
                    totalDocs={this.state.pagination?.totalDocs}
                    onPageChange={this.handlePageChange}
                    onEntriesPerPageChange={this.handleEntriesPerPageChange}
                  />
                </MDBox>
                {/* <>
                  <MDSnackbar
                    color={this.state.noticolor}
                    icon="notifications"
                    title="AgriQuiz"
                    content={this.state.message}
                    dateTime="Just now"
                    open={this.state.notification}
                    //   close={toggleSnackbar}
                  />
                </> */}
              </Card>
            </MDBox>
          </DashboardLayout>
        </div>
      );
    }
  }
}
